module.exports = __webpack_public_path__ + "img/dealer-tree-people.cc238a64.svg";